import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    DialogContentText, CircularProgress,
} from "@material-ui/core";
import { appConstants } from '../domain/constant/app.constant';

import moment from 'moment';
import { useState, useEffect } from 'react';

import requestDeadlineService from '../domain/services/request/request.deadline.service'
import supportContactService from '../domain/services/support.contact.service';

export default function ExtendDueDateModal({ open, onClose, request, setFieldValue, setAlert }) {

    const [ceilingDate, setCeilingDate] = useState("");
    const [modalType, setModalType] = useState('loading');
    const [isLoading, setIsLoading] = useState(false);

    const faciliterName = JSON.parse(localStorage.getItem('@facilita-app/user')).name;
    const userId = JSON.parse(localStorage.getItem('@facilita-app/user')).id;

    const handleCeilingError = (error) => {
        if (error?.response?.data?.canUnlink)
            return setModalType('insufficient');

        setAlert(error?.response?.data?.message || 'Não é possível pedir prorrogação agora', 'error');
        handleClose();
    }

    const loadExtensionCeiling = async () => {
        setModalType('loading');
        try {
            const response = await requestDeadlineService.checkExtensionDeadlinePossibility(request.id, userId);
            setCeilingDate(response.data.maxOperationalDueDate);
            setModalType(response.data.canUnlink ? 'insufficient' : 'initial');
        }
        catch (error) {
            handleCeilingError(error);
        }
    }

    useEffect(() => {
        if (open) loadExtensionCeiling();
    }, [open]);

    const handleClose = async () => {
        await onClose();
        setModalType('loading');
    }

    const handleExtendToCeiling = async () => {
        setIsLoading(true);
        setFieldValue("operationalDueDate", ceilingDate);
        await requestDeadlineService
            .updateOperationalDueDateByExtension(request.id, userId, ceilingDate)
            .then(() => {
                handleClose();
                setAlert('Prazo prorrogado até o máximo permitido. Cumpra o novo prazo para evitar penalidade.', 'success');
            })
            .catch(() => setAlert('Erro ao prorrogar o prazo', 'error'))
            .finally(() => setIsLoading(false));
    }

    const handleUnlink = async () => {
        setIsLoading(true);
        await requestDeadlineService
            .unlinkFromExtension(request.id, userId)
            .then(() => {
                handleClose();
                setAlert('Você foi desvinculado e a solicitação voltou para a central para re-roteamento.', 'success');
            })
            .catch(() => setAlert('Erro ao desvincular do serviço', 'error'))
            .finally(() => setIsLoading(false));
    }

    const formattedCeiling = ceilingDate ? moment(ceilingDate).format('DD/MM/YYYY [às] HH:mm') : '';

    const loadingButton = (label) => isLoading
        ? <span><CircularProgress m={2} style={{ marginLeft: '5px', width: '16px', height: '16px' }} /></span>
        : label;

    const getLoadingModal = () => (
        <>
            <DialogTitle>Olá, {faciliterName}</DialogTitle>
            <DialogContent style={{ textAlign: 'center', padding: '2rem' }}>
                <CircularProgress />
                <DialogContentText style={{ marginTop: '1rem' }}>
                    Calculando o prazo máximo que você pode prorrogar...
                </DialogContentText>
            </DialogContent>
        </>
    );

    const getInitialModal = () => (
        <>
            <DialogTitle>Olá, {faciliterName}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    O prazo máximo que você pode prorrogar, sem exceder o prazo de entrega ao cliente, é:
                </DialogContentText>
                <DialogContentText style={{ marginTop: '1rem', marginBottom: '1rem', fontSize: '1.1rem', color: '#000', fontWeight: 'bold' }}>
                    {formattedCeiling}
                </DialogContentText>
                <DialogContentText style={{ color: 'red' }}>
                    Se você não entregar até esse prazo, será penalizado por atraso na entrega.
                </DialogContentText>
                <DialogContentText style={{ marginTop: '1rem' }}>
                    Lembre-se que você não poderá pedir outra prorrogação pelas próximas 5 entregas.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleClose} disabled={isLoading}>
                    Cancelar
                </Button>
                <Button variant="contained" onClick={handleExtendToCeiling} color="primary" disabled={isLoading}>
                    {loadingButton("Prorrogar até esse prazo")}
                </Button>
            </DialogActions>
        </>
    );

    const getInsufficientModal = () => (
        <>
            <DialogTitle>{faciliterName}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Não é possível prorrogar: mesmo o prazo máximo já ultrapassaria o prazo de entrega ao cliente.
                </DialogContentText>
                <DialogContentText style={{ marginTop: '1rem' }}>
                    Se você não vai conseguir concluir, pode desistir do serviço agora. A solicitação volta para a central e é re-roteada para outro profissional.
                </DialogContentText>
                <DialogContentText style={{ marginTop: '1rem', color: 'red' }}>
                    Lembre-se de que a desvinculação impacta a sua pontualidade. Em caso de dúvida, fale com o suporte antes pelo e-mail {appConstants.faciliterSupportEmail}.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleClose} disabled={isLoading}>
                    Cancelar
                </Button>
                <Button variant="contained" color="secondary" onClick={handleUnlink} disabled={isLoading}>
                    {loadingButton("Desistir do serviço")}
                </Button>
                <a href={supportContactService.supportUrl()}>
                    <Button variant="contained">Falar com o Suporte</Button>
                </a>
            </DialogActions>
        </>
    );

    const ModalTypes = {
        loading: getLoadingModal,
        initial: getInitialModal,
        insufficient: getInsufficientModal,
    }

    return (
        <Dialog open={open} maxWidth="xs" fullWidth onClose={(event, reason) => reason !== 'backdropClick' && handleClose}>
            {(ModalTypes[modalType] || getLoadingModal)()}
        </Dialog>
    );
}
